import Image from "next/image";
import React from "react";

const SkewedBar = ({
  header,
  subHeader,
  subHeaderColor,
  headerCSS,
}) => {
  return (
    <>
      <div className="flex gap-[2px]">
        {/* <div          
          className={`md:w-[35px]  md:h-[75px] w-[25px] h-[65px] bg-[${color}] whatWeDoBar edgeBar `}
        ></div> */}
        <Image
          src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
          width={64}
          height={72}
          className="relative sm:top-[-2.2rem] logo-height"
          alt="Elchemy-brand-logo"
        />
        <div className="">
          <div
            className={
              headerCSS
                ? headerCSS
                : `sm:text-[1rem] text-[0.875rem] text-red font-medium uppercase font-mukta mb-[4px]`
            }
          >
            {header}
          </div>
          <div
            className={`md:text-[40px] font-light text-[1.5rem] text-[#161616] text-[${subHeaderColor}] font-mukta`}
          >
            {subHeader}
          </div>
        </div>
      </div>
    </>
  );
};

export default SkewedBar;
